module.exports = __webpack_public_path__ + "media/11.1800e450.mp3";